<template>
    <div>
      <list-table
        :url="url"
        title="لیست مشتریان"
        :fields="fields"
        :params="params"
        :excelroute="'asdasd'"
      ></list-table>
    </div>
  </template>
    <script>
  import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
  import TableShowData from "../../components/table";
  import moment from 'jalali-moment';
import persianDate from '../../helpers/persianDate';
  
  export default {
    name: "incomes",
    data() {
      return {
        url: "accounters-report/get-factors",
        val1: null,
        val2: null,
        params: [
          {
            label: "تاریخ",
            field: "date",
            type: "date-picker",
            value:persianDate.getDate(new Date())
          },
        ],
        fields: [
          {
            key: "name",
            label: "نام مشتری",
          },
          {
            key: "date",
            label: "از ابتدای ماه تا تاریخ",
          },
          {
            key: "bed",
            label: "مبلغ",
            formatter(value, key, item) {
              return Number(value).toLocaleString();
            },
          }
        ],
        // detailUrl:"SharingDetails",
      };
    },
    components: {
      "list-table": TableShowData,
    },
    computed: {
      loadedComparative() {
        return this.$store.getters.loadedComparative;
      },
      loadedMoein() {
        return this.$store.getters.loadedMoein;
      },
    },
    methods: {},
    created() {},
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست فاکتور ها" }]);
    },
  };
  </script>